module.exports = __webpack_public_path__ + "static/scale-model-of-leslie-science-and-nature-center-in-ann-arbor-michigan-3c91d2fc042d3ed3a62dfcf0287bb043.png";